import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "video",
  "use": "video-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"video\"><path fill-rule=\"evenodd\" d=\"M2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2Zm6-4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H8Zm4 3.5 6 4.5-6 4.5v-9Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol